import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import {
  bootstrapAuthHeaders,
  setAuthTokens,
  clearAuthTokens,
} from "../lib/api";

const API = process.env.REACT_APP_BACKEND_URL;
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Re-attach Authorization header from stored token on cold boot
    bootstrapAuthHeaders();
    axios
      .get(`${API}/api/auth/me`, { withCredentials: true })
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await axios.post(
      `${API}/api/auth/login`,
      { email, password },
      { withCredentials: true }
    );
    // Store JWT for cross-site setups (custom domain ↔ emergent.host)
    setAuthTokens({
      access_token: data?.access_token,
      refresh_token: data?.refresh_token,
    });
    setUser(data);
    return data;
  };

  const logout = async () => {
    // Optional API call — never blocks the UI
    try {
      await axios.post(`${API}/api/auth/logout`, {}, { withCredentials: true });
    } catch (e) {
      // silent
    }
    clearAuthTokens();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export function formatApiError(detail) {
  if (!detail) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
